const BillingConfigApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/billing-config/get`,
    POST: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/billing-config/create`,
    PUT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/billing-config/update`,
    DELETE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/billing-config/delete`,
};

export default BillingConfigApiUrls